import {useState,useEffect,useCallback} from 'react';
import api from '../../../services/api';
import {PRODUTO_VAZIO} from '../constants';

export function useProdutos(){
  const [produtos,setProdutos]=useState([]);
  const [maquinas,setMaquinas]=useState([]);
  const [funcionarios,setFuncionarios]=useState([]);
  const [loading,setLoading]=useState(true);
  const [salvando,setSalvando]=useState(false);
  const [modalForm,setModalForm]=useState(null);
  const [form,setForm]=useState(PRODUTO_VAZIO);

  const carregar=useCallback(async()=>{
    setLoading(true);
    try{
      const [pR,mR,fR]=await Promise.all([
        api.get('/produtos/produtos/?page_size=1000'),
        api.get('/maquinas/maquinas/?page_size=1000'),
        api.get('/funcionarios/funcionarios/?page_size=1000'),
      ]);
      setProdutos(pR.data.results||pR.data);
      setMaquinas(mR.data.results||mR.data);
      setFuncionarios(fR.data.results||fR.data);
    }catch(e){console.error(e);}
    finally{setLoading(false);}
  },[]);

  useEffect(()=>{carregar();},[carregar]);

  // Atualiza produto individual sem recarregar tudo
  const atualizarProduto=useCallback(async(id)=>{
    try{
      const res=await api.get('/produtos/produtos/'+id+'/');
      setProdutos(prev=>prev.map(p=>p.id===id?res.data:p));
    }catch{carregar();}
  },[carregar]);

  const abrirNovo=useCallback((defaults={})=>{
    setForm({...PRODUTO_VAZIO,...defaults});
    setModalForm('novo');
  },[]);

  const abrirEditar=useCallback((p)=>{
    setForm({...p});
    setModalForm('editar');
  },[]);

  const fecharModal=useCallback(()=>setModalForm(null),[]);

  const excluir=useCallback(async(id)=>{
    if(!window.confirm('Excluir produto?'))return;
    try{
      await api.delete('/produtos/produtos/'+id+'/');
      setProdutos(prev=>prev.filter(p=>p.id!==id));
    }catch(e){
      const msg=e.response?.data?.erro||'Erro ao excluir produto.';
      alert(msg);
    }
  },[]);

  const duplicar=useCallback(async(p)=>{
    const novoCodigo=p.codigo+'-COPIA';
    if(!window.confirm('Duplicar produto como "'+novoCodigo+'"?'))return;
    try{
      const {composicao,processos,tabela_precos,fornecedores,historico_precos,
             processo_detalhe,processo_montagem,id,criado_em,atualizado_em,...dados}=p;
      const res=await api.post('/produtos/produtos/',{...dados,codigo:novoCodigo,nome:p.nome+' (Copia)',estoque:'0',preco_custo:'0'});
      const novoProdutoId=res.data.id;
      if(composicao&&composicao.length>0){
        await Promise.all(composicao.map(c=>api.post('/produtos/composicao/',{produto:novoProdutoId,componente:c.componente,quantidade:c.quantidade,unidade:c.unidade})));
      }
      carregar();
    }catch{alert('Erro ao duplicar. Verifique se o codigo ja existe.');}
  },[carregar]);

  const salvar=useCallback(async(classeAuto,origemAuto)=>{
    setSalvando(true);
    const {id,codigo,nome,categoria,classe,tipo,origem,unidade,ncm,cfop,csosn,ean,
           preco_custo,estoque,estoque_minimo,estoque_maximo,localizacao,ativo,descricao}=form;
    const dados={codigo,nome,categoria,classe:classeAuto||classe,tipo,origem:origemAuto||origem,
                 unidade,ncm,cfop,csosn,ean,preco_custo,estoque,estoque_minimo,
                 estoque_maximo,localizacao,ativo,descricao};
    try{
      if(modalForm==='novo')await api.post('/produtos/produtos/',dados);
      else await api.put('/produtos/produtos/'+id+'/',dados);
      carregar();fecharModal();
    }catch{alert('Erro ao salvar produto.');}
    finally{setSalvando(false);}
  },[form,modalForm,carregar,fecharModal]);

  const setF=useCallback((field,value)=>{
    setForm(prev=>({...prev,[field]:value}));
  },[]);

  return {produtos,maquinas,funcionarios,loading,salvando,form,modalForm,
    setForm,setF,carregar,atualizarProduto,
    abrirNovo,abrirEditar,fecharModal,excluir,duplicar,salvar};
}

